import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.FossilFinder;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "FossilFinder.Phaser.IntroductionScene.1",
            "FossilFinder.Phaser.IntroductionScene.2",
            "FossilFinder.Phaser.IntroductionScene.3",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/FossilFinderGame/scenes/GameIntro.ts